// extracted by mini-css-extract-plugin
module.exports = {"forgotten-password-link":"styles__forgotten-password-link___1gb7Y"};